module.exports = __webpack_public_path__ + "img/bg_hezuo2.d1360509.png";